<template>
<div class="elg-tag-group">
  <el-row :gutter="20">
    <el-col :span="girdNumber" v-for="(btn, idx) in parentList" :key="idx">
      <el-button
        style="width: 100%;"
        :class="btn.value === parentValue ? 'egl-btn-white-gray-border act' : 'egl-btn-white-gray-border'"
        :key="idx"
        @click="$emit('update:parentValue', parentList[idx].value)"
        :disabled="isAutoUpdate && btn.value"
      >{{ btn.label }}</el-button>
    </el-col>
  </el-row>
</div>
</template>
<script>
export default {
  computed: {
    girdNumber() {
      return this.parentList.length === 2 ? 12 : 8
    }
  },
  props: {
    parentValue: {
      type: String | Boolean,
      required: true
    },
    parentList: {
      type: Array,
      // default: () => ["あり", "なし"],
      default: () => [
        {
          label: "あり",
          value: true
        },
        {
          label: "なし",
          value: false
        }
      ]
    },
    isAutoUpdate: {
      type: Boolean,
      default: false
    }
  }
}
</script>